import { Link } from "react-router-dom"
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { IoToday } from "react-icons/io5";

export default function Home(){
    return (
        <div className="main-body">
            <div className="container">
                <img 
                    src="/maine.webp"
                    alt="a view from the top of a hill" 
                    id="main-img"
                    className="main-img" 
                    width="660px"
                    height="357px"
                />
            
                <div className="home-text">
                    <h1>Welcome</h1>
                    <p>This is my modest slice of the internet - no algorithms, no ads, just me tinkering with code and sharing whatever catches my interest. It's a work in progress, but isn't that the point?</p>
                    <p>I enjoy climbing to the top of moderately sized hills and taking pictures.</p>
                </div>   

                <div className="home-card">
                    <div className="home-card-img">
                        <FaExternalLinkSquareAlt />
                    </div>
                    <div className="link-text">
                        <Link to="/Links"><h2>Links</h2></Link>
                        <p className="link-quote">I plan to add more in the future but for now I have a list of *things* I have found interesting</p>
                    </div>
                </div>
                <div className="home-card">
                    <div className="home-card-img">
                        <IoToday />
                    </div>
                    <div className="link-text">
                        <Link to="/now"><h2>Now</h2></Link>
                        <p className="link-quote">Here is what I'm up to now.</p>    
                    </div>
                </div>
            </div>
        </div>
    )
}